/**
 * NotificationInboxService
 * Mobile / web notification inbox + history — `GET /api/notifications/me`
 * and `POST /api/notifications/me/read` on CCMS.Api.Communications.
 *
 * This endpoint is NOT behind a microservice path prefix (it lives directly at
 * `/api/notifications`), so the service uses an empty servicePath — mirroring
 * the Swift + Kotlin SDK inbox clients.
 */
import { BaseService } from '../base/BaseService';
export class NotificationInboxService extends BaseService {
    constructor(http, config) {
        super(http, {
            // The inbox controller lives in the Communications service, reached
            // through the gateway's /communications/ prefix (which strips the prefix
            // and forwards /api/notifications/...). So route via 'communications',
            // NOT the empty prefix — /api/notifications has no gateway rule.
            servicePath: config?.servicePath ?? 'communications',
            basePath: NotificationInboxService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Fetch the calling user's notification inbox / history.
     * @param appId optional constellation appId filter (e.g. "ccms.task").
     * @param since optional ISO-8601 watermark for incremental sync.
     */
    async fetchMyInbox(appId, since) {
        const response = await this.fetchMyInboxRaw(appId, since);
        return response.data ?? { userId: '', count: 0, items: [] };
    }
    fetchMyInboxRaw(appId, since) {
        const url = this.buildUrlWithParams('me', { appId, since });
        return this.http.get(url);
    }
    /**
     * Marks notifications in the caller's inbox as read. Read-state persists
     * server-side so it stays consistent across the user's devices.
     */
    async markRead(request) {
        const response = await this.markReadRaw(request);
        return response.data ?? { updated: 0 };
    }
    markReadRaw(request) {
        const url = this.buildUrl('me/read');
        return this.http.post(url, request);
    }
}
NotificationInboxService.BASE_PATH = 'api/notifications';
//# sourceMappingURL=NotificationInboxService.js.map